module.exports = __webpack_public_path__ + "static/img/prince_photo.a13cc9be.png";